import { Field, ErrorMessage } from 'formik';
import { twMerge } from 'tailwind-merge'

const CheckboxCard = ({ name, label, description = '', className = '', checkboxClassName = '', labelClassName = '', action = null, onChange = null }) => (
  <Field name={name} type="checkbox">
    {({ field }) => (
      <div className="flex h-full flex-col">
        <label className={twMerge("flex flex-1 flex-col gap-3 border border-base-300 rounded-xl p-4 cursor-pointer transition-colors has-[:checked]:border-green-200 has-[:checked]:bg-green-50 sm:flex-row sm:items-start sm:gap-4", className)}>
          <span className="min-w-0 flex-1">
            <span className="flex items-start gap-3">
              <input
                {...field}
                type="checkbox"
                onChange={onChange || field.onChange}
                className={twMerge("checkbox checkbox-sm shrink-0 [--chkbg:theme(colors.green.500)] [--chkfg:white] border-gray-300 checked:border-green-500", checkboxClassName)}
              />
              <span className={twMerge("text-sm font-medium", labelClassName)}>{label}</span>
            </span>
            {description && <p className="text-gray-500 mt-1 text-xs pl-8">{description}</p>}
          </span>
          {action && <span className="shrink-0 pl-8 sm:self-center sm:pl-0">{action}</span>}
        </label>
        <ErrorMessage name={name} render={(msg) => (
          <p className="text-error text-xs mt-1 ml-1">{msg}</p>
        )} />
      </div>
    )}
  </Field>
);

export default CheckboxCard;
